import { getXPartner } from "@/app/utils/helper";

interface ReferralTagPayload {
    refCode: string;
    referral: string;
}

export const getUserRefarrals = async () => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/ref/activity/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                // "X-partner": "orobonds:default",
            },
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const getUserReferalDetail = async () => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/ref/getOneLink/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                // "X-partner": "orobonds:default",
                "X-partner": getXPartner(),
            },
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
}

export const getUserRefarralActivities = async () => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/ref/myReferrals/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                // "X-partner": "orobonds:default",
            },
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
}

export const getUserRewards = async () => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/orobonds/users/portfolio/rewards`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-product": "orobonds:default",
                "x-web-version": "1.10.3",
                "X-partner": getXPartner(),
            },
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
}

export const referralTag = async (payload: ReferralTagPayload) => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/ref/tag`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error while tagging referral", err);
    }
};